
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"9","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5.272 4.5c0-.972.774-1.76 1.728-1.76s1.728.788 1.728 1.76S7.954 6.26 7 6.26 5.272 5.472 5.272 4.5zm1.127 0c0 .338.27.612.601.612a.607.607 0 00.601-.612A.607.607 0 007 3.888a.607.607 0 00-.601.612z","fill":"#585858"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.539 1.262l3.14 2.557A.879.879 0 0114 4.5a.879.879 0 01-.321.681l-3.14 2.557a5.59 5.59 0 01-7.077 0L.322 5.18A.879.879 0 010 4.5c0-.265.118-.516.321-.681l3.14-2.557a5.59 5.59 0 017.078 0zM4.16 6.88a4.494 4.494 0 005.68 0l2.87-2.38-2.87-2.342a4.494 4.494 0 00-5.68 0L1.29 4.5l2.87 2.38z","fill":"#585858"}})])
          )
        }
      }
    